import constants from "../../constants";
import errorMessageFilter from "../../filters/errorMessageFilter";

const cauHinhLuongUtils = {
  //point được nối từ nút bắt đầu
  isBatDauPoint(point) {
    return (
      point.vbStepForm &&
      (point.vbStepForm.posType === constants.STEP_POS_TYPE.BAT_DAU ||
        point.vbStepForm.posType === constants.STEP_POS_TYPE.BOTH)
    );
  },

  //point được kêt nối tới nút kết thúc;
  isKetThucPoint(point) {
    return (
      point.vbStepForm &&
      (point.vbStepForm.posType === constants.STEP_POS_TYPE.KET_THUC ||
        point.vbStepForm.posType === constants.STEP_POS_TYPE.BOTH)
    );
  },

  isEndPoint(point) {
    return point.type === constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.END;
  },

  isStartPoint(point) {
    return point.type === constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.START;
    //  || (point.vbStepForm && point.vbStepForm.posType === 0);
  },

  isStartPointByPostype(point) {
    return (point.vbStepForm && point.vbStepForm.posType === 0);
  },

  isOutgoingFlow(vbFlowForm) {
    return vbFlowForm.flowType === constants.FLOW_TYPE.VB_DI;
  },

  isIncomingFlow(vbFlowForm) {
    return vbFlowForm.flowType === constants.FLOW_TYPE.VB_DEN;
  },

  getFlowTypeName(flowType) {
    switch (flowType) {
      case constants.FLOW_TYPE.VB_DI:
        return errorMessageFilter({ errorCode: "vbFlow.flowType.outgoing" });
      case constants.FLOW_TYPE.VB_DEN:
        return errorMessageFilter({ errorCode: "vbFlow.flowType.incoming" });
    }
  }
};

export default cauHinhLuongUtils;



// WEBPACK FOOTER //
// ./src/services/cauhinhluong/cauHinhLuongUtils.js